import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import 'firebase/firestore';
import { Left, Right } from 'fp-ts/lib/Either';
import { curry } from 'fp-ts/lib/function';
import { logging, utils } from '@heimdall/core-common';
import { app } from '../firebase-factory';
var logger = logging.instantiateLogger('heimdall:core:common:client:firebase:firestore');
export function connect(appName) {
  try {
    return app.lookup(appName).chain(function (result) {
      return new Right(result.firestore());
    });
  } catch (err) {
    return new Left(err);
  }
}

function generateQuery(firestore, location) {
  return location.reduce(function (accum, c, i) {
    if (i & 1) {
      return accum.doc(c);
    } else {
      return accum.collection(c);
    }
  }, firestore);
}

function getDocumentTaskFunction(firestore, location) {
  return utils.TaskUtils.taskEitherWrapper(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var log, queryResult, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log = logger.extend('getDocumentTask');
            _context.next = 3;
            return generateQuery(firestore, location).get();

          case 3:
            queryResult = _context.sent;
            data = queryResult.data();
            log("Doc Data: ".concat(JSON.stringify(data)));

            if (!(data !== undefined)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", data);

          case 10:
            log("Document at ".concat(location, " does not exist"));
            throw new Error("Document at ".concat(location, " does not exist"));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
}

function getDocumentsTaskFunction(firestore, location) {
  return utils.TaskUtils.taskEitherWrapper(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var log, queryResult, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            log = logger.extend('getDocumentsTaskFunction');
            _context2.next = 3;
            return generateQuery(firestore, location).get();

          case 3:
            queryResult = _context2.sent;
            data = queryResult.data();
            log("Doc Data: ".concat(JSON.stringify(data)));

            if (!(data !== undefined)) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", data);

          case 10:
            log("Document at ".concat(location, " does not exist"));
            throw new Error("Document at ".concat(location, " does not exist"));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
}

function setDocumentTaskFunction(firestore, collection, docId, data) {
  return utils.TaskUtils.taskEitherWrapper(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var log;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            log = logger.extend('setDocumentTask');
            log("Setting Document ".concat(docId));
            _context3.prev = 2;
            _context3.next = 5;
            return firestore.collection(collection).doc(docId).set(data);

          case 5:
            return _context3.abrupt("return", _context3.sent);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](2);
            log(_context3.t0);
            throw _context3.t0;

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 8]]);
  })));
}

export var getDocumentTask = curry(getDocumentTaskFunction);
export var getDocumentTasks = curry(getDocumentsTaskFunction);
export var setDocumentTask = curry(setDocumentTaskFunction);